import React, { useEffect, useState } from "react";
import classes from "./PopUp.module.css";
import { Modal } from "antd";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { useNavigate } from "react-router-dom";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";

const PopUp = ({ data, isModalOpen, setIsModalOpen, image, setpopUpOnce }) => {
  const width = useDeviceWidth();
  console.log("set once branch", setpopUpOnce);
  const navigate = useNavigate();
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const [responsiveTitle, setResponsiveTitle] = useState("");

  useEffect(() => {
    //html content will rearrange fontsize when window width changes
    if (data) {
      setResponsiveHtml(
        AdjustFontSize(
          data?.description, width
        )
      );
      setResponsiveTitle(
        AdjustFontSize(
          data?.title, width
        )
      );
    }
  }, [data, width]);

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => {
    setpopUpOnce(1);
    setIsModalOpen(false);
    localStorage.setItem("popupopened", false);
  };
  console.log("banner data", data);

 
  return (
    <div className="popup-modals">
      <Modal
        // title="My Modal"
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        // style={{ borderRadius: 50 }}
        // bodyStyle={{ borderRadius: 50 }}
        className="popup-modal"
        closeIcon={
          <img src="/img/close-icon.svg" className={classes.closeIcon} alt="close" />
        }
        width={width > 1024 ? 700 : width > 768 ? 600 : "88vw"}
        centered
      >
        <div className={classes.outer}>
          <img src={image} alt="popup image" />
          <div className={classes.content}>
            <p dangerouslySetInnerHTML={{ __html: responsiveTitle }}></p>
            <span className={classes.htmlDescription}
              dangerouslySetInnerHTML={{ __html: responsiveHtml }}
            ></span>
            <button
              className="border-primary-500 primary-hover"
              onClick={() => {
                setIsModalOpen(false);
                setpopUpOnce(1);
                navigate("/consultation")}}
            >
              Book Your Appointment Today
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PopUp;
